import styled, { css } from 'styled-components';
import { VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';

import colors from '../../../../../../../styles/colors';
import { ReactComponent as TrashIcon } from '../../../../../../../assets/icons/v2/trash.svg';
import { ReactComponent as EditIcon } from '../../../../../../../assets/icons/v2/edit-blue.svg';
import { ReactComponent as PinIcon } from '../../../../../../../assets/icons/v2/pin-outline.svg';
import { ReactComponent as UnpinIcon } from '../../../../../../../assets/icons/v2/pin-off.svg';

const iconStyle = css`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: ${colors.shades.secondary8};
`;

const StyledTrashIcon = styled(TrashIcon)`
  path {
    fill: none;
    stroke: ${colors.base.danger};
  }
  ${iconStyle};
`;

const StyledEditIcon = styled(EditIcon)`
  ${iconStyle};
`;

const StyledPinIcon = styled(PinIcon)`
  ${iconStyle};
`;

const StyledUnpinIcon = styled(UnpinIcon)`
  ${iconStyle};
`;

const StyledHideIcon = styled(VisibilityOffIcon)`
  ${iconStyle};
  width: 18px;
  height: 18px;
`;

const DeleteText = styled.span`
  color: ${colors.base.danger};
`;

export {
  StyledTrashIcon as TrashIcon,
  StyledEditIcon as EditIcon,
  StyledPinIcon as PinIcon,
  StyledUnpinIcon as UnpinIcon,
  StyledHideIcon as HideIcon,
  DeleteText,
};
